import {
  getFromLocalStorage,
  saveToLocalStorage,
} from "src/utils/localStorage";

const STORAGE_KEY = "reportSavedBoxes";
// Caps how many distinct reports keep their saved box content in localStorage -
// without this, every report ever opened added an entry that was never pruned,
// eventually filling the 5MB/origin quota.
const MAX_SAVED_REPORTS = 50;

export const getReportSavedBoxes = () => getFromLocalStorage(STORAGE_KEY) || {};

export const saveReportSavedBoxes = (reportId, boxes) => {
  const reportSavedBoxes = getReportSavedBoxes();
  const updated = { ...reportSavedBoxes, [reportId]: boxes };

  const reportIds = Object.keys(updated);
  if (reportIds.length > MAX_SAVED_REPORTS) {
    reportIds
      .slice(0, reportIds.length - MAX_SAVED_REPORTS)
      .forEach((id) => delete updated[id]);
  }

  saveToLocalStorage(STORAGE_KEY, updated);
};
